import React from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "./styles.css";

const PowerBIReport = ({ accessToken, workspaceId, reportId }) => {
  const embedConfig = {
    type: "report",
    id: reportId,
    embedUrl: `https://app.powerbi.com/reportEmbed?groupId=${workspaceId}&reportId=${reportId}`,
    accessToken: accessToken,
    tokenType: models.TokenType.Aad,
    settings: {
      panes: {
        filters: {
          visible: false,
        },
        pageNavigation: {
          visible: true,
        },
      },
    },
  };

  return (
    <PowerBIEmbed
      embedConfig={embedConfig}
      cssClassName={"powerbi-embed"}
      getEmbeddedComponent={(embeddedReport) => {
        console.log("Embedded Report Instance", embeddedReport);
      }}
      eventHandlers = {
        new Map([
          ['loaded', function () {console.log('Report loaded');}],
          ['rendered', function () {console.log('Report rendered');}],
          ['error', function (event) {console.log(event?.detail);}],
          ['visualClicked', () => console.log('visual clicked')],
          ['pageChanged', (event) => console.log(event)],
        ])
      }
    />
  );
};

export default PowerBIReport;